<!--
 * @Description: 
 * @Author: jinxiaojian
 * @Email: jinxiaojian@youxin.com
 * @Date: 2019-07-05 13:03:35
 * @LastEditTime: 2019-08-25 17:10:51
 * @LastEditors: 靳肖健
 -->
<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "index",
};
</script>
<style lang="scss">
@import "@/scss/base.scss";
body {
  display: flex;
}
#app {
  flex: 1;
}
</style>
